import { render } from "./ProjectsDashboard.vue?vue&type=template&id=e41daf92&scoped=true"
import script from "./ProjectsDashboard.vue?vue&type=script&lang=js"
export * from "./ProjectsDashboard.vue?vue&type=script&lang=js"

import "./ProjectsDashboard.vue?vue&type=style&index=0&id=e41daf92&lang=css"
import "./ProjectsDashboard.vue?vue&type=style&index=1&id=e41daf92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e41daf92"]])

export default __exports__